import { AxiosError } from "axios";
import { CountryListItem, SelectedCountry } from "../types/common";

export const getError = (name: string, errors: any) => {
  if (!Object.keys(errors).length) return undefined;

  return name
    .split(".")
    .map((item) => item.replaceAll("[", "").replaceAll("]", ""))
    .reduce((prev, curr: any) => (prev ? prev[curr] : prev), errors);
};

export const getCountryId = (countryList: CountryListItem[]) => {
  const country = getSelectedCountry();

  if (countryList && country) {
    const countryData: any = countryList?.filter(
      (item: any) => item.textValue === country?.label
    );
    return countryData[0];
  }
};

export const getSelectedCountry = (): SelectedCountry | undefined => {
  const selectedCountry = sessionStorage.getItem("selectedCountry");
  return selectedCountry
    ? (JSON.parse(selectedCountry) as SelectedCountry)
    : undefined;
};

export const getLanguageCode = () => {
  let language: any = sessionStorage.getItem("defaultLanguage");
  language = JSON.parse(language);
  if (language) {
    const languageData = language?.filter((item: any) => item.isDefault);
    return languageData[0]?.languageCode;
  } else {
    return "";
  }
};

export const getDropdownData = (data: any, defaultLabel = "", type = "") => {
  let temp: any = [{ label: defaultLabel, value: "" }];
  if (type && data) {
    Object.entries(data).forEach(([key, value]) => {
      temp.push({ label: value, value: value });
    });
    return temp;
  }
  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      temp.push({ label: value, value: key });
    });
  }
  return temp;
};

export const getApiErrorMessages = (
  error: any,
  defaultMessage: string = "Something went wrong, please try again after some time."
) => {
  let message = defaultMessage;
  if (error instanceof AxiosError) {
    if (error.response?.data?.error) {
      const _error = error.response.data.error;
      if (typeof _error === "string") {
        message = _error;
      } else if (Array.isArray(_error) && _error.length > 0) {
        message = _error[0].message;
      }
    }
  }
  return message.split(";");
};
